import { DOCUMENT } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { UserStateService } from './shared/state/user.state';

import { RouterModule } from '@angular/router';
import { MenuComponent } from './menu/menu.component';
import { FooterComponent } from './footer/footer.component';
import { NotificationStateComponent } from './shared/notification/notification-state.component';
import { DemoBannerComponent } from './shared/demo-banner/demo-banner.component';
import { StateCleaner } from './shared/state/state-cleaner.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    MenuComponent,
    FooterComponent,
    NotificationStateComponent,
    DemoBannerComponent,
  ],
})
export class AppComponent {
  private static readonly LEGACY_THEME_STYLESHEET_ID = 'legacy-theme-stylesheet';
  private static readonly LEGACY_CUSTOM_STYLESHEET_ID = 'legacy-custom-stylesheet';

  userState = inject(UserStateService);
  private stateCleaner = inject(StateCleaner);
  private document = inject(DOCUMENT);

  readonly isAuthenticated = this.userState.isAuthenticated;

  constructor() {
    effect(() => {
      const isAuth = this.isAuthenticated();

      this.syncLegacyThemeStyles(isAuth);

      if (!isAuth) {
        this.stateCleaner.cleanAllStates();
        this.userState.cleanPaymentState();
      }
    });
  }

  private syncLegacyThemeStyles(isAuthenticated: boolean): void {
    if (isAuthenticated) {
      this.ensureLegacyStylesheet(
        AppComponent.LEGACY_THEME_STYLESHEET_ID,
        'assets/stylesheets/theme.css'
      );
      this.ensureLegacyStylesheet(
        AppComponent.LEGACY_CUSTOM_STYLESHEET_ID,
        'assets/stylesheets/custom.css'
      );
      return;
    }

    this.removeLegacyStylesheet(AppComponent.LEGACY_THEME_STYLESHEET_ID);
    this.removeLegacyStylesheet(AppComponent.LEGACY_CUSTOM_STYLESHEET_ID);
  }

  private ensureLegacyStylesheet(id: string, href: string): void {
    if (this.document.getElementById(id)) {
      return;
    }

    const link = this.document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    this.document.head.appendChild(link);
  }

  private removeLegacyStylesheet(id: string): void {
    this.document.getElementById(id)?.remove();
  }
}
